<ng-container *transloco="let t">
  <div class="certificate-form">
    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Remove patch') }}</mat-label>
      <input
        matInput
        [matDatepicker]="removePatchPicker"
        [formControl]="removePatch"
        placeholder="dan/mesec/godina"
      
          [min]="minDate" [max]="today"
        />
      <mat-datepicker-toggle
        matSuffix
        [for]="removePatchPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #removePatchPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput [formControl]="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
